import { atom } from "recoil"

export const myProfileRequestIdState = atom({
  key: "atoms/organization/myProfile/myProfileRequestIdState",
  default: 0,
})
